/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { FC } from 'react';
import AutoSuggestComponent from '@aarhus-university/au-lib-react-components/src/components/AUAutoSuggestComponent';
import { sortAlphaObj } from '@aarhus-university/au-lib-react-components/src/lib/helpers';
import { useGetAutoSuggestsQuery } from '../services/api';

type AutoSuggestResult = {
  name: string;
  value: string;
};

const getSuggestions = (
  value: string,
  collection: AutoSuggestResult[],
  callback: (results: AutoSuggestResult[]) => void,
): void => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  const result = inputLength < 2 ? []
    : collection.filter((x: AutoSuggestResult) => x.name.toLowerCase().indexOf(inputValue) > -1)
      .sort(sortAlphaObj);
  callback(result);
};

const SearchComponent: FC<SearchComponentProps> = ({
  setSearch,
}: SearchComponentProps) => {
  const { data } = useGetAutoSuggestsQuery();

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
      }}
    >
      <div className="service-areas__search-container">
        <h1>{window.serviceemp_header}</h1>
        <p dangerouslySetInnerHTML={{ __html: window.serviceemp_text }} />
        <div className="service-areas__search" role="search">
          <label htmlFor="service-areas-search">{`${window.serviceemp_search}:`}</label>
          <AutoSuggestComponent
            placeholder=""
            setResults={(results: AutoSuggestResult[]) => {
              if (results.length === 1) {
                setSearch(results[0].name);
              }
            }}
            collection={data?.map((x) => ({
              name: x,
              value: x,
            }))}
            getSuggestions={getSuggestions}
            getSuggestionValue={(suggestion: AutoSuggestResult) => suggestion.name}
            renderSuggestion={(suggestion: AutoSuggestResult) => <div className="service-areas__search__item">{suggestion.name}</div>}
          />
        </div>
        <div className="service-areas__search-hint">
          {window.serviceemp_hint}
        </div>
      </div>
    </form>
  );
};

SearchComponent.displayName = 'SearchComponent';
export default SearchComponent;
